import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "xpage-content-page",
  id: "xsearch-page"
}
const _hoisted_2 = { class: "xpage-inner section" }
const _hoisted_3 = {
  name: "xpage-searchbar-wrapper",
  class: "search-page-searchbar-wrapper"
}
const _hoisted_4 = { class: "xpage-inner section" }
const _hoisted_5 = { class: "search-page-search-wrapper" }
const _hoisted_6 = {
  key: 0,
  name: "xpage-searchfilters-wrapper",
  class: "search-page-searchfilters-wrapper"
}
const _hoisted_7 = { class: "xpage-searchresults-wrapper" }

import { onMounted, watch, ref, onBeforeMount, PropType, computed } from "vue";
import Page from "@/components/layout/Page.vue";
import Loader from "@/components/Loader.vue";
import SearchPageBreadcrumbs from "@/components/v2/search-page/SearchPageBreadcrumbs.vue";
import SearchPageLayoutButtons from "@/components/v2/search-page/SearchPageLayoutButtons.vue";
import SearchPageSearchBar from "@/components/v2/search-page/SearchPageSearchBar.vue";
import SearchPageFilters from "@/components/v2/search-page/SearchPageFilters.vue";
import SearchPageSearchResults from "@/components/v2/search-page/SearchPageSearchResults.vue";
import SearchPageMobileMenu from "@/components/v2/search-page/SearchPageMobileMenu.vue";
import SearchPageSearchBarDropdownResults from "@/components/v2/search-page/SearchPageSearchBarDropdownResults.vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import { useRoute, useRouter } from "vue-router";
import * as jsonpatch from "fast-json-patch";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPage',
  props: {
  pageName: {
    type: String,
    default: "",
  },
  searchBoxPlaceholderText: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const route = useRoute();

const router = useRouter();

const props = __props;

const searchPageStore = useSearchPageStore();

const loading = ref<boolean>(true);

const filters = computed(() => searchPageStore.searchPageState.filters);

const searchPageState = computed(() => searchPageStore.searchPageState);

const showFilters = computed<boolean>(() => filters.value?.length > 0);

async function checkQueryChanges(oldValue, newValue) {
  interface Patch {
    op: string;
    path: string;
    value?: any;
  }

  const ignoreKeys = ["Layout", "CollapsedFilters", "ExpandedFilters"];

  const keysThatTriggerSearch = [
    "pageNumber",
    "PageNumber",
    "pageSize",
    "PageSize", 
    "resultSortKey",
    "resultSortOrder",
  ];

  const difference = jsonpatch.compare(oldValue, newValue);

  if (difference.length === 0) {
    return;
  }

  const changedKeys = difference.map(
    (difference: Patch) => difference.path.split("/")[1]
  );

  const shouldSearch = changedKeys.some(
    (key) => !ignoreKeys.includes(key)
  );

  if (!shouldSearch) {
    return;
  }
  
  const isPageChangeOnly = changedKeys.every((key) => 
    keysThatTriggerSearch.includes(key)
  );

  const currentPage = newValue.pageNumber ?? newValue.PageNumber ?? 1;

  if (!isPageChangeOnly && currentPage !== 1) {
    searchPageStore.setPaginationPageNumber(1);

    await router.replace({
      query: {
        ...newValue,
        pageNumber: 1,
      },
    });

    return;
  }

  await searchPageStore.getParametersFromUrl(props.pageName);
  await searchPageStore.searchEntities();
}

watch(
  () => route.query,
  async (currentValue, oldValue) => {
    await checkQueryChanges(oldValue, currentValue);
  }
);

watch(
  () => props.pageName,
  async (currentValue) => {
    searchPageStore.searchPageState.entity = currentValue;
    searchPageStore.searchPageState.pageName = currentValue;
  }
);

watch(
  () => route.params,
  async () => {
    await searchPageStore.getParametersFromUrl(props.pageName);
  }
);

watch(
  () => filters.value.length,
  async (currentValue, oldValue) => {
    if (currentValue > 0) {
      await searchPageStore.getParametersFromUrl(props.pageName);
    }
  }
);

onMounted(async () => {
  searchPageStore.searchPageState.pageName = props.pageName;

  // #TODO if the localstore has any recently viewed records
  // if (localStorage.getItem(`cache.RecentlyViewedPages_${props.pageName}`)) {
  //   // retreive the data from localstorage
  //   applications.recentlyViewed = JSON.parse(
  //     localStorage.getItem(cache.RecentlyViewedPages_${props.pageName})
  //   ).filter((item) => item.page == props.pageName.toLowerCase());
  // }
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value || !showFilters.value)
      ? (_openBlock(), _createBlock(Loader, { key: 0 }))
      : (_openBlock(), _createBlock(Page, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(SearchPageBreadcrumbs, {
              pageName: props.pageName
            }, null, 8, ["pageName"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(SearchPageLayoutButtons, {
                onChangeLayout: _unref(searchPageStore).changeLayout,
                settings: searchPageState.value
              }, null, 8, ["onChangeLayout", "settings"]),
              _createElementVNode("h2", null, _toDisplayString(props.pageName), 1),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(SearchPageSearchBar, {
                  pageName: __props.pageName,
                  searchBoxPlaceholderText: __props.searchBoxPlaceholderText
                }, null, 8, ["pageName", "searchBoxPlaceholderText"]),
                _createVNode(SearchPageSearchBarDropdownResults, { pageName: __props.pageName }, null, 8, ["pageName"]),
                _createVNode(SearchPageMobileMenu)
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (showFilters.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(SearchPageFilters, {
                        filterDefinitions: _unref(searchPageStore).searchPageState.filters,
                        settings: _unref(searchPageStore).searchPageState
                      }, null, 8, ["filterDefinitions", "settings"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(SearchPageSearchResults, {
                  pageName: props.pageName
                }, null, 8, ["pageName"])
              ])
            ])
          ]),
          _: 1
        }))
  ]))
}
}

})